import script from "./FormulasIngredient.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredient.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredient.vue?vue&type=style&index=0&id=0ec92ca8&lang=scss"

const __exports__ = script;

export default __exports__